import React, { useMemo } from 'react';
import SolAirdrop from "./solAirDrop";

export default function App() {
  return (
          <>
            <SolAirdrop />
          </>
  );
}